import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import OktaUserInfo from '../auth/okta-user-info';
import { UserProfile } from '../auth/types';

const Profile: React.FC = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (authState.isAuthenticated) {
        try {
          // Get user info from Okta
          const user = await oktaAuth.getUser();
          if (user) {
            const profile: UserProfile = {
              email: user.email || '',
              firstName: user.given_name || '',
              lastName: user.family_name || '',
              sub: user.sub || '',
            };
            setUserProfile(profile);
            // Update stored user info
            OktaUserInfo.setOktaUserInfo(profile);
          }
        } catch (error) {
          console.error('Error fetching user profile:', error);
          // Fallback to stored user info
          setUserProfile(OktaUserInfo.getOktaUserInfo());
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUserProfile();
  }, [authState.isAuthenticated, oktaAuth]);

  const handleLogout = async () => {
    try {
      await oktaAuth.signOut();
      OktaUserInfo.clearOktaUserInfo();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (!authState.isAuthenticated) {
    return <div>Loading...</div>;
  }

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading profile...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px' }}>
      <h1>User Profile 👤</h1>
      
      <div style={{ 
        background: '#f8f9fa', 
        padding: '30px', 
        borderRadius: '8px',
        marginBottom: '20px',
        border: '1px solid #e0e0e0'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '20px' 
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#007bff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '24px',
            fontWeight: 'bold',
            margin: '0 auto 15px'
          }}>
            {OktaUserInfo.getOktaInitials()}
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <strong>First Name:</strong>
          <div style={{ 
            padding: '8px', 
            backgroundColor: 'white', 
            border: '1px solid #ccc', 
            borderRadius: '4px',
            marginTop: '5px'
          }}>
            {userProfile?.firstName || 'Not provided'}
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <strong>Last Name:</strong>
          <div style={{ 
            padding: '8px', 
            backgroundColor: 'white', 
            border: '1px solid #ccc', 
            borderRadius: '4px',
            marginTop: '5px'
          }}>
            {userProfile?.lastName || 'Not provided'}
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <strong>Email:</strong>
          <div style={{ 
            padding: '8px', 
            backgroundColor: 'white', 
            border: '1px solid #ccc', 
            borderRadius: '4px',
            marginTop: '5px'
          }}>
            {userProfile?.email || 'Not provided'}
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <strong>User ID (sub):</strong>
          <div style={{ 
            padding: '8px', 
            backgroundColor: 'white', 
            border: '1px solid #ccc', 
            borderRadius: '4px',
            marginTop: '5px',
            fontSize: '12px',
            fontFamily: 'monospace'
          }}>
            {userProfile?.sub || 'Not provided'}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <button
          onClick={() => window.location.href = '/home'}
          style={{
            padding: '10px 20px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Back to Home
        </button>
        
        <button
          onClick={handleLogout}
          style={{
            padding: '10px 20px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Profile;